const VERSIONED_KEYS: Record<string, string> = {
  user_info: "user_info:v1",
  impersonator_user_info: "impersonator_user_info:v1",
};

const SESSION_ONLY_KEYS = new Set(["auth_token", "impersonator_token"]);

const resolveStorageKey = (key: string): string => VERSIONED_KEYS[key] ?? key;

const getWindowStorage = () => {
  if (typeof window === "undefined") return null;
  return {
    local: window.localStorage,
    session: window.sessionStorage,
  };
};

export const storage = {
  getItem: (key: string): string | null => {
    const stores = getWindowStorage();
    if (!stores) return null;

    const versionedKey = resolveStorageKey(key);
    if (SESSION_ONLY_KEYS.has(key)) {
      const sessionValue =
        stores.session.getItem(versionedKey) ?? stores.session.getItem(key);
      if (sessionValue) return sessionValue;

      const legacyValue =
        stores.local.getItem(versionedKey) ?? stores.local.getItem(key);
      if (legacyValue) {
        stores.session.setItem(versionedKey, legacyValue);
        stores.local.removeItem(versionedKey);
        stores.local.removeItem(key);
      }
      return legacyValue;
    }

    return stores.local.getItem(versionedKey) ?? stores.local.getItem(key);
  },

  setItem: (key: string, value: string): void => {
    const stores = getWindowStorage();
    if (!stores) return;

    const versionedKey = resolveStorageKey(key);
    if (SESSION_ONLY_KEYS.has(key)) {
      stores.session.setItem(versionedKey, value);
      stores.local.removeItem(versionedKey);
      stores.local.removeItem(key);
      return;
    }

    stores.local.setItem(versionedKey, value);
  },

  removeItem: (key: string): void => {
    const stores = getWindowStorage();
    if (!stores) return;

    const versionedKey = resolveStorageKey(key);
    for (const store of [stores.session, stores.local]) {
      if (versionedKey !== key) {
        store.removeItem(versionedKey);
      }
      store.removeItem(key);
    }
  },
};
